// auth-services AuthProvider: how the account signs in.
const AUTH_PROVIDER_LABEL: Record<number, string> = {
  1: "Email",
  2: "Google",
  3: "Facebook",
  4: "Apple",
  5: "Guest",
};

// auth-services UserAttribution.source: where the signup came from (utm / gclid / fbclid), not the login method.
const SIGNUP_SOURCE_LABEL: Record<string, string> = {
  google: "Google",
  facebook: "Facebook",
  instagram: "Instagram",
  meta: "Meta (Facebook / Instagram)",
};

export const signedUpWithLabel = (authProvider: number | null | undefined): string => {
  if (authProvider === null || authProvider === undefined) return "—";
  return AUTH_PROVIDER_LABEL[authProvider] ?? `Unknown (${authProvider})`;
};

export const cameFromLabel = (signupSource: string | null | undefined): string => {
  if (!signupSource) return "Organic / direct";
  return SIGNUP_SOURCE_LABEL[signupSource] ?? signupSource;
};
